export class PositionZeitraum {
    // BT-134
    startdatum: string | undefined
    // BT-135
    enddatum: string | undefined

    toJSON() {
        return !!this.startdatum || !!this.enddatum
            ? {
                  startdatum: this.startdatum?.substr(0, 10),
                  enddatum: this.enddatum?.substr(0, 10),
              }
            : undefined
    }
}
